export default __webpack_public_path__ + "static/website-preview-909bdc0b412062432e76a1e449c7a6f4.png";